<template>
    <div class="full-modal">
        <div class="btn-exit" @click="ExitModal"><i class="pi pi-times"></i></div>
        <h1 class="top-text">Add Benefit</h1>
        <div class="add-existing" v-if="!createNewBenefit">
            <h3>Select a code to add</h3>
            <select v-model="selectedDropDownItem" class="hover-grow" :class="{'input-incorrect': (this.userTriedToClick && this.selectedDropDownItem === '')}">
                <!-- Placeholder option -->
                <option disabled value="">Select code</option>
                <option v-for="(code, index) in codes" :key="index" :value="code">{{ code.code }} - {{ code.name }}</option>
                <option :value="'ADD_NEW'">+ Add New Benefit</option>
            </select>
            <button class="submit-btn hover-grow" @click="AddExistingBenefit">Add Benefit</button>
        </div>
        <div class="add-new" v-else>
            <div class="data-row">
                <h4 class="data-row-text">Name:</h4>
                <input class="data-row-input hover-grow" :class="{'input-incorrect': (this.benefit.name === '' && this.userTriedToClick)}" type="text" v-model="benefit.name"/>
            </div>
            <!-- <div class="data-row">
                <h4 class="data-row-text">Technical Name:</h4>
                <input class="data-row-input" type="text" v-model="benefit.technicalName"/>
            </div> -->
            <div class="data-row">
                <h4 class="data-row-text">Code:</h4>
                <input class="data-row-input hover-grow" :class="{'input-incorrect': ((this.benefit.code === '' && this.userTriedToClick) || codeAlreadyExists)}" type="text" v-model="benefit.code"/>
            </div>
            <div class="data-row">
                <h4 class="data-row-text">UCR:</h4>
                <input class="data-row-input hover-grow" :class="{'input-incorrect': (this.benefit.UCR === 0 && this.userTriedToClick)}" type="text" v-model="benefit.UCR" @input="ValidatePrice($event, 'UCR')"/>
            </div>
                <button class="submit-btn hover-grow" @click="AddNewBenefit">Add Benefit</button>
                <div class="modal-bottom-spacer"></div>
            </div>
            <p class="error-message" v-if="!createNewBenefit" :class="{ 'hidden': !hasDefaultValues || !userTriedToClick }">Please select a benefit to add</p>
            <p class="error-message" v-else :class="{ 'hidden': !hasDefaultValues || !userTriedToClick }">Please fill out all fields to add this benefit</p>
            <p class="error-message" :class="{ 'hidden': !codeAlreadyExists }">A benefit with this code already exists</p>

    </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
    props: {
        addOnID: Number,
    },
    data() {
        return {
            benefit: {
                name: "",
                technicalName: "",
                code: "",
                UCR: 0,
            },
            selectedOption: "Add Existing Benefit",
            createNewBenefit: false,
            selectedDropDownItem: "",
            userTriedToClick: false,
            inputClasses: {
                'data-row-input': true,
                'hover-grow': true,
            },
            codeAlreadyExists: false,
            
        }
    },
    mounted() {
        window.addEventListener('keydown', this.handleEscape);
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.handleEscape);
    },
    methods: {
        ...mapActions(['addBenefitStore', 'updateBenefitByIDStore', 'addBenefitToAddOn']),
        ExitModal() {
            this.$emit('exitModal');
        },
        AddExistingBenefit() {
            if(this.selectedDropDownItem === ""){
                this.userTriedToClick = true;
                if(this.userTriedToClick && this.selectedDropDownItem === ''){
                    console.log("Error conditions met- turn the select red");
                }
                return;
            }
            let newBenefitID = this.selectedDropDownItem.id;
            this.addBenefitToAddOn([newBenefitID, this.addOnID])
            this.ExitModal();
        },
        AddNewBenefit() {
            this.userTriedToClick = true;
            if(this.hasDefaultValues) {
                return;
            }
            if(this.$store.getters.existsCode(this.benefit.code)) {
                this.codeAlreadyExists = true;
                return;
            }
            let newBenefit = this.benefit;
            newBenefit['planTypes'] = [];
            newBenefit['prices'] = {};
            newBenefit['frequencies'] = {};
            this.$store.dispatch('addBenefitStore', this.benefit).then(newId => {
                //console.log("NewBenefitID = ", newId);
                // Proceed with your logic here
                this.addBenefitToAddOn([newId, this.addOnID]);
                this.ExitModal();
            });
        },
        ValidatePrice(event, fieldName) {
            //console.log("Entering validate");
            const cleanedPrice = event.target.value.replace(/\D/g, '');
            this.benefit[fieldName] = parseInt(cleanedPrice, 10) || 0;
        },
        handleEscape(event) {
            if(event.key === 'Escape') {
                this.ExitModal();
            }
        },
    },
    computed: {
        codes() {
            let allBenefits = this.$store.state.benefits
            let addOnBenefits = this.$store.getters.getAddOnBenefits(this.addOnID)
            // let result = allBenefits.filter(benefit => !addOnBenefits.includes(benefit))
            return allBenefits
        },
        hasDefaultValues() {
            if(this.benefit.name === "" || this.benefit.code === "" || this.benefit.UCR === 0) {
                return true;
            }
            else {return false;}
        },
    },
    watch: {
    selectedDropDownItem(newVal, oldVal) {
        //console.log("New value = ", newVal)
        if(newVal === 'ADD_NEW') {
            this.createNewBenefit = true;
        }
    }
}
}
</script>

<style scoped>

.full-modal {
    position: relative;
    width: 30%;
    min-width: 280px;
    max-height: 90vh;
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 20px;
    border: 3px solid var(--color-dark-blue);
    outline: 2px solid white;
    padding: 2%;
    overflow-y: auto;
    box-sizing: border-box;
}

.btn-exit {
    position: absolute;
    top: 20px;
    right: 25px;
    color: red;
    font-size: 1.75em;
    cursor: pointer;
    font-family: sans-serif
}

.top-text {
    color: var(--font-color-teal);
    margin-top: 0.25em;
    flex-shrink: 0;
}

.add-existing {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-shrink: 0;
}

select {
    background-color: white;
    border: 2px solid var(--color-light-gray);
    border-radius: 5px;
    padding: 5px 10px;
    font-size: 16px;
    cursor: pointer;
}

select:hover {
    border: 2px solid var(--color-light-blue);
}

.add-new {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    flex-shrink: 0;
}

.data-row{
    width: 85%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 12%;
    flex-shrink: 0;
}

.data-row-text {
    font-size: 1.2em;
}

.data-row-input {
    height: 20px;
    border-radius: 5px;
    border: 2px solid var(--color-medium-light-gray);
    transition: border-color 0.2s ease;
}

.input-incorrect {
    border: 2px solid var(--color-light-red) !important;
}

.data-row-input:hover {
    border: 2px solid var(--color-light-blue);
}

.data-row-input:focus {
    outline: none;
    border: 2px solid var(--color-bright-blue);
}

.checkbox {
    position: relative;
    margin-right: 9.4em;
    margin-bottom: 2em;
}

.submit-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 3px solid var(--color-light-blue);
    border-radius: 40px;
    height: 2.25em;
    background-color: white;
    color: var(--color-bright-blue);
    font-size: 1.4em;
    font-weight: 600;
    padding-right: 0.7em;
    padding-left: 0.7em;
    cursor: pointer;
    margin-top: 1em;
    box-shadow: 3px 3px 5px var(--color-light-gray);
    flex-shrink: 0;
}

.submit-btn:active {
    border: 3px solid var(--color-dark-blue)
}

.error-message {
    margin: 0;
    color: var(--color-medium-red);
    flex-shrink: 0;
}

.error-message.hidden {
    visibility: hidden;
}

.modal-bottom-spacer {
    min-height: 0.5em;
    flex-shrink: 0;
}
</style>